export const categoryImages = [{
    category: 'Prove Me Wrong',
    alt: 'prove Me Wrong',
    description: 'A man holding a sign that says prove me wrong',
    url: 'https://qdpammoeepwgapqyfrrh.supabase.co/storage/v1/object/public/speak-it-brand-assets/ProveMeWrong.png'
} , {
    category: 'Entertainment',
    alt: 'Entertainment',
    description: 'A Lady Singing',
    url:'https://qdpammoeepwgapqyfrrh.supabase.co/storage/v1/object/public/speak-it-brand-assets/entertainment.png'
}, {
    category: 'Philosophy',
    alt: 'Philosophy',
    description: 'Frederick Douglass contemplating',
    url:'https://qdpammoeepwgapqyfrrh.supabase.co/storage/v1/object/public/speak-it-brand-assets/philosophy.png'
}, {
    category: 'Relationships',
    alt: 'Relationships',
    description: 'A smiling couple',
    url:'https://qdpammoeepwgapqyfrrh.supabase.co/storage/v1/object/public/speak-it-brand-assets/relationships.png'
}, {
    category: 'Politics',
    alt: 'Politics',
    description: 'Malcolm X',
    url:'https://qdpammoeepwgapqyfrrh.supabase.co/storage/v1/object/public/speak-it-brand-assets/Malcolm-x_colorized_photo.jpg'
}, {
    category: 'War',
    alt: 'War',
    description: 'Generals facing each other',
    url:'https://qdpammoeepwgapqyfrrh.supabase.co/storage/v1/object/public/speak-it-brand-assets/war.png'
}

];